// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CodeMirror-code{font-family:Menlo,Monaco,Consolas,Courier New,monospace}", ""]);
// Exports
module.exports = exports;
